import React from 'react';

const renderCell = (item, column) => {
  const value = getCellValue(item, column.accessor);

  if (column.render) {
    return column.render(value, item);
  }

  return <span className={column.className}>{value}</span>;
};

const getCellValue = (item, accessor) => {
  if (!accessor) {
    return '';
  }

  if (typeof accessor === 'function') {
    return accessor(item);
  }

  const keys = accessor.split('.');
  let value = item;

  for (const key of keys) {
    if (value && value.hasOwnProperty(key)) {
      value = value[key];
    } else {
      value = '';
      break;
    }
  }

  return value;
};

const Row = ({ item, columns }) => {
  return (
    columns &&
    columns.map((column, colIndex) => (
      <td key={colIndex} colSpan={column.colSpan} className={column.cellClassName}>
        {renderCell(item, column)}
      </td>
    ))
  );
};

export default Row;
